import { render, staticRenderFns } from "./DetalleCompraTabla.vue?vue&type=template&id=1050039e&scoped=true"
import script from "./DetalleCompraTabla.vue?vue&type=script&lang=js"
export * from "./DetalleCompraTabla.vue?vue&type=script&lang=js"
import style0 from "./DetalleCompraTabla.vue?vue&type=style&index=0&id=1050039e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1050039e",
  null
  
)

export default component.exports